import { formatDate } from 'utils/DatesUtils';
import { getRelevantEventDay } from 'utils/EventDateUtils';

const joinNonEmpty = (parts, separator = ', ') =>
  parts.filter((part) => part && String(part).trim()).join(separator);

export const isFullDayEventDay = ({ startTime, endTime }) => {
  if (!startTime || !endTime) {
    return true;
  }

  const normalizedStart = startTime.trim();
  const normalizedEnd = endTime.trim();

  if (/ganz/i.test(normalizedStart) || /ganz/i.test(normalizedEnd)) {
    return true;
  }

  return (
    normalizedStart === '00:00' &&
    (normalizedEnd === '23:59' || normalizedEnd === '24:00' || normalizedEnd === '00:00')
  );
};

export const formatEventDayParts = (eventDay) => ({
  value: formatDate(eventDay.date),
});

export const formatLocationParts = (location = {}, meetingLink) => {
  if (meetingLink) {
    return { value: 'Online' };
  }

  return { value: location.city };
};

export const formatRegistrationDeadlineParts = (registrationDeadline) =>
  registrationDeadline
    ? {
        label: 'Anmeldeschluss:',
        value: formatDate(registrationDeadline),
      }
    : null;

export const formatAvailabilityParts = ({
  maxParticipants,
  eventParticipantsNumber,
  isRegistrationExpired,
  disableMaxParticipation,
}) => {
  if (isRegistrationExpired || disableMaxParticipation) {
    return null;
  }

  const freePlaces = maxParticipants - eventParticipantsNumber;

  if (freePlaces <= 0) {
    return { value: 'Ausgebucht' };
  }

  if (freePlaces === 1) {
    return { value: '1 Platz frei' };
  }

  return { value: `${freePlaces} Plätze frei` };
};

export const formatFeeParts = (chargingAmount) => {
  const amount = chargingAmount ? chargingAmount.replace('.', ',') : '0';

  return {
    label: 'Gebühr:',
    value: `${amount}€`,
  };
};

export const getEventDaysForDisplay = (eventDays = []) => {
  if (!eventDays.length) {
    return [];
  }

  const relevantDay = getRelevantEventDay(eventDays);

  if (relevantDay) {
    return [relevantDay, ...eventDays.filter((day) => day.date !== relevantDay.date)];
  }

  return eventDays;
};
